import {AuthModel} from './_models'

type Ambiente = 'dev' | 'qas' | 'prd'
const AMBIENTE_ENV = process.env.REACT_APP_AMBIENTE as Ambiente | undefined

const AUTH_KEYS: Record<Ambiente, string> = {
  dev: 'kt-auth-dev-boreservas',
  qas: 'kt-auth-qas-boreservas',
  prd: 'kt-auth-prd-boreservas',
}

// const AUTH_LOCAL_STORAGE_KEY = AUTH_KEYS[AMBIENTE_ENV];
const AUTH_LOCAL_STORAGE_KEY = AMBIENTE_ENV ? AUTH_KEYS[AMBIENTE_ENV] : AUTH_KEYS.dev

// const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-reservas'

// const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'
const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: {headers: {Authorization: string}}) => {
      const auth = getAuth()
      if (auth && auth.access_token) {
        config.headers.Authorization = `Bearer ${auth.access_token}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )
}

export {getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY}
